import styled, { css } from 'styled-components';
import { PrimaryLink, PrimaryRouterLink } from '@qover/molecules';
import { SitemapMixin } from '@qover/typography';

export const CompletionBar = styled.div<{ completionPercentage: number }>`
  background-color: ${({ theme }) => theme.colors.primary()};
  height: 2px;
  max-width: 100%;
  width: ${props => props.completionPercentage || 0}%;

  @media screen and (min-width: ${({ theme }) =>
      theme.breakpoints.minWidth.S}) {
    display: none;
  }
`;

export const PartnershipWith = styled.div`
  ${SitemapMixin};
  color: ${({ theme }) => theme.colors.textQuote()};
  display: flex;
  align-items: center;
  margin-left: 10px;
  white-space: nowrap;
  & > * {
    margin: 0 10px;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.S}) {
    margin: 0;
    margin-top: 5px;
  }
`;

const ComputeButtonCss = css`
  margin-left: 20px;

  & > svg {
    fill: ${({ theme }) => theme.colors.primaryButtonText()};
    height: 8px;
    margin-right: 15px;
    stroke: ${({ theme }) => theme.colors.primaryButtonText()};
    width: 14px;
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.S}) {
    display: none;
  }
`;

export const ComputeButtonRouterLink = styled(PrimaryRouterLink)`
  ${ComputeButtonCss};
`;

export const ComputeButtonLink = styled(PrimaryLink)`
  ${ComputeButtonCss};
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 30px 80px;

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.M}) {
    padding: 30px;
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.S}) {
    box-shadow: 0 2px 4px 0 rgba(25, 25, 25, 0.2);
    padding: 15px;
  }
`;

export const Inner = styled.div`
  background-color: ${({ theme }) => theme.colors.headerBackground()};
  width: 100%;

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.S}) {
    display: block;
    position: static;
    visibility: visible !important;

    &.fixed {
      display: none;
    }
  }
`;

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-right: 5px;
`;

export const MainLogoContainer = styled.div`
  margin-right: 5px;
  img {
    max-height: 40px;
    max-width: 250px;

    @media screen and (max-width: 600px) {
      max-height: 30px;
      max-width: 100px;
    }
  }

  svg {
    height: 40px;
    width: 250px;

    @media screen and (max-width: 600px) {
      height: 30px;
      width: 100px;
    }
  }
`;

export const PartnerLogoContainer = styled.div`
  img {
    max-height: 30px;
    max-width: 250px;

    @media screen and (max-width: 600px) {
      max-height: 15px;
      max-width: 100px;
    }
  }

  svg {
    height: 30px;
    width: 75px;

    @media screen and (max-width: 600px) {
      height: 15px;
      width: 100px;
    }
  }
`;

export const RightContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
`;

export const TopBarContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.headerBackground()};
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.colors.textQuote(0.1)};
  position: relative;
  width: 100%;
  z-index: 10;
  &.sticky {
    position: sticky;
    top: 0;
  }
`;
